import { InjectionToken } from '@angular/core';

import { SharedStorageService } from './shared-storage.service';
import { StorageServiceConfig } from './shared-storage-service-config.interface';

export const STORAGE_SERVICE = new InjectionToken<SharedStorageService>('SharedStorageService');
export const SHARED_STORAGE_SERVICE_CONFIG = new InjectionToken<StorageServiceConfig>('SharedStorageServiceConfig');
